// Copyright (c) 2016 Deere & Company

import AppConfig, {getDefaultState} from '../../shared/models/app-config';
import actions from '../actions-list';

const updateAppConfig = (state, action) =>
    AppConfig.update(state, {
        $set: action.data
    });

const updateSelectedSapEnvironment = (state, action) =>
    AppConfig.update(state, {
        sapEnvironments: {
            $set: action.payload
        }
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.READ_APP_CONFIG_SUCCESS]: updateAppConfig,
        [actions.UPDATE_SELECTED_SAP_ENVIRONMENT]: updateSelectedSapEnvironment
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/app-config/reducers/app-config.js